// Enhanced Sheets API with Analytics Support
const sheetsAPI = (() => {
  const baseURL = CONFIG.SHEETS_API_URL;

  // ---- low-level helpers (no custom headers → no CORS preflight)
  const get = async (action, params = {}) => {
    const qs = new URLSearchParams({ action, ...params }).toString();
    const url = `${baseURL}?${qs}`;
    const res = await fetch(url);
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return res.json();
  };

  const post = async (action, params = {}) => {
    const body = new URLSearchParams({ action, ...params });
    const res = await fetch(baseURL, { method: 'POST', body });
    const response = await SheetsAPI.getTestConfig();
    console.log(response);
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return res.json();
  };

  // Normalize registration payload
  const normRegisterPayload = (input) => {
    if (typeof FormData !== 'undefined' && input instanceof FormData) {
       return {
      email:            input.get('email') || '',
      password:         input.get('password') || '',
      full_name:        input.get('full_name') || '',
      contact_number:   input.get('contact_number') || '', 
      isbn_number:      input.get('isbn_number') || '',
      country:          input.get('country') || '',
      state:            input.get('state') || '',
      school:           input.get('school') || '',
      grade:            input.get('grade') || '',
      act_attempt_date: input.get('act_attempt_date') || ''
    };
  }
  // in case someone calls it with a plain object
  return {
    email:            input.email || '',
    password:         input.password || '',
    full_name:        input.full_name || input.fullName || '',
    contact_number:   input.contact_number || '',           
    isbn_number:      input.isbn_number || input.isbn || '',
    country:          input.country || '',
    state:            input.state || '',
    school:           input.school || '',
    grade:            input.grade || '',
    act_attempt_date: input.act_attempt_date || input.actDate || ''
  };
};


  return {
    // ---- ISBN
    validateISBN: (isbn) => get('verifyISBN', { isbn_number: isbn }),

    // ---- Auth / Profile
    register: (data) => post('registerUser', normRegisterPayload(data)),
    login: (email, password) => post('loginUser', { email, password }),
    getUserByUID: (uid) => get('getUserByUID', { uid }),
    updateUser: (uid, updates) => post('updateUser', { uid, updates: JSON.stringify(updates) }),

    requestPasswordReset: (email) => post('requestPasswordReset', { email }),
    verifyResetToken: (token) => get('verifyResetToken', { token }),
    resetPassword: (token, newPassword) => post('resetPassword', { token, new_password: newPassword }),

    // ---- Test Configuration & Answer Keys
    getTestConfig: (test_id) => get('getTestConfig', test_id ? { test_id } : {}),
    
    
    getAnswerKeys: (test_id) => get('getAnswerKeys', { test_id }),
    
    // ---- Test Responses
    saveResponses: (responses) => post('saveResponses', { responses: JSON.stringify(responses) }),
    getUserResponses: (uid) => get('getUserResponses', { uid }),

    // ---- Student Test Management
    getAllTests: () => get('getAllTests'),
    
    /**
     * Get student responses for a specific test
     * @param {Object} params - { uid, test_id }
     * @returns {Object} Response with student answers and status
     */
    getStudentResponses: (params) => get('getStudentResponses', params),
    
    /**
     * Save student responses (for in-progress tests)
     * @param {Object} d - Response data
     */
    saveStudentResponses: (d) => post('saveStudentResponses', {
      uid: d.uid, 
      test_id: d.test_id,
      english_answers: d.english_answers,
      math_answers: d.math_answers,
      reading_answers: d.reading_answers,
      status: d.status, 
      last_section: d.last_section
    }),
    
    /**
     * Submit test for grading
     * @param {Object} d - Submission data
     */
    submitTest: (d) => post('submitTest', {
      uid: d.uid, 
      test_id: d.test_id,
      english_answers: d.english_answers,
      math_answers: d.math_answers,
      reading_answers: d.reading_answers,
      submitted_at: d.submitted_at
    }),
    
    /**
     * Get student's complete test history with scores
     * Returns array of test attempts with:
     * - test_id, test_name, submitted_at
     * - composite_score
     * - english_score, english_correct, english_total
     * - math_score, math_correct, math_total
     * - reading_score, reading_correct, reading_total
     * - difficulty breakdown (optional)
     * - domain breakdown (optional)
     * 
     * @param {Object} params - { uid }
     * @returns {Object} { success: true, data: [...] }
     */
    getStudentTestHistory: (params) => get('getStudentTestHistory', params),
    
    /**
     * Get detailed analytics for a specific test attempt
     * Includes difficulty-wise and domain-wise breakdowns
     * 
     * @param {Object} params - { uid, test_id }
     * @returns {Object} Detailed analytics data
     */
    getTestAnalytics: (params) => get('getTestAnalytics', params),
    
    /**
     * Get overall analytics across all tests for a student
     * Aggregates performance by difficulty and domain
     * 
     * @param {Object} params - { uid }
     * @returns {Object} Aggregated analytics data
     */
    getOverallAnalytics: (params) => get('getOverallAnalytics', params)
  };
})();

// Export to window for global access
window.SheetsAPI = sheetsAPI;   
window.sheetsAPI = sheetsAPI;